function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M256.011,42.689c-64.704,0-117.333,52.629-117.333,117.333c0,5.888,4.779,10.667,10.667,10.667h213.333 c5.888,0,10.667-4.779,10.667-10.667C373.344,95.318,320.715,42.689,256.011,42.689z M160.608,149.355 c5.312-47.936,46.08-85.333,95.403-85.333s90.069,37.397,95.403,85.333H160.608z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M362.678,192.022H149.344c-5.888,0-10.667,4.779-10.667,10.667v170.667c0,25.771,18.347,47.317,42.667,52.267v54.4 c0,17.643,14.357,32,32,32c17.643,0,32-14.357,32-32v-53.333h21.333v53.333c0,17.643,14.357,32,32,32s32-14.357,32-32v-54.4 c24.32-4.971,42.667-26.496,42.667-52.267V202.689C373.344,196.801,368.566,192.022,362.678,192.022z M352.011,373.356 c0,17.643-14.357,32-32,32c-5.888,0-10.667,4.779-10.667,10.667v64c0,5.888-4.779,10.667-10.667,10.667 s-10.667-4.779-10.667-10.667v-64c0-5.888-4.779-10.667-10.667-10.667h-42.667c-5.888,0-10.667,4.779-10.667,10.667v64 c0,5.888-4.779,10.667-10.667,10.667s-10.667-4.779-10.667-10.667v-64c0-5.888-4.779-10.667-10.667-10.667 c-17.643,0-32-14.357-32-32v-160h192V373.356z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 213.344,
  cy: 117.355,
  r: 10.667
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 298.678,
  cy: 117.355,
  r: 10.667
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M426.678,192.022c-17.643,0-32,14.357-32,32v106.667c0,17.643,14.357,32,32,32c17.643,0,32-14.357,32-32V224.022 C458.678,206.38,444.32,192.022,426.678,192.022z M437.344,330.689c0,5.888-4.779,10.667-10.667,10.667 c-5.888,0-10.667-4.779-10.667-10.667V224.022c0-5.888,4.779-10.667,10.667-10.667c5.888,0,10.667,4.779,10.667,10.667V330.689z"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M85.344,192.022c-17.643,0-32,14.357-32,32v106.667c0,17.643,14.357,32,32,32c17.643,0,32-14.357,32-32V224.022 C117.344,206.38,102.987,192.022,85.344,192.022z M96.011,330.689c0,5.888-4.779,10.667-10.667,10.667 s-10.667-4.779-10.667-10.667V224.022c0-5.888,4.779-10.667,10.667-10.667s10.667,4.779,10.667,10.667V330.689z"
})));

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M223.776,57.75L201.803,6.486c-2.304-5.44-8.64-7.957-13.995-5.589c-5.419,2.304-7.915,8.576-5.611,13.995l21.973,51.264 c1.728,4.053,5.675,6.464,9.813,6.464c1.408,0,2.837-0.256,4.203-0.853C223.584,69.441,226.102,63.169,223.776,57.75z"
})));

var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M324.192,0.875c-5.355-2.347-11.691,0.192-13.995,5.611L288.224,57.75c-2.325,5.419,0.192,11.669,5.611,13.995 c1.365,0.597,2.795,0.875,4.203,0.875c4.139,0,8.085-2.411,9.813-6.464l21.952-51.285C332.128,9.451,329.611,3.201,324.192,0.875z "
})));

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

var _ref24 = /*#__PURE__*/React.createElement("g", null);

var SvgAndroid = function SvgAndroid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.022 512.022",
    style: {
      enableBackground: "new 0 0 512.022 512.022"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAndroid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/android.65614040.svg";
export { ForwardRef as ReactComponent };